export default __webpack_public_path__ + "static/media/bell.06a1b5eb.svg";